import React from "react";
import LanguageIcon from "@mui/icons-material/Language";
import {
  Box,
  Button,
  Typography,
  useMediaQuery,
  useTheme,
  Grid,
  IconButton,
  Paper,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';

export default function Chef() {
  const data = [
    {
      image: "./images/iMac Memoji2.svg",
      title: "Chef Juna Food",
      rating: "4.7",
      review:' ( 150 Reviews )',
    },
  ];

  return (
    
      <Box>
            <Box sx={{
                width:'100%',
                display:'flex',
                flexDirection:'row',
                alignItems:{lg:'start',md:'start',sm:'start',xs:'center'},
                justifyContent:'space-between'
            }}>
                <Box sx={{width:{lg:'80%',md:'80%',sm:'80%',xs:'100%'}}}>
                    
                    {data.map((v, i) => {
                    return (
                        <>
                        
                            
                                        <Box component="container">
                                        <Box
                                            sx={{
                                            width: "100%",
                                            height: "120px",
                                            display: "flex",
                                            flexDirection: "row",
                                            gap: "16px",
                                            pt: "12px",
                                            pl: "14px",
                                            }}
                                        >
                                            <Box sx={{ width: "96px", height: "96px" }}>
                                            <img src={v.image} alt="" width="100%" />
                                            </Box>

                                            <Box>
                                            <Box>
                                                <Typography
                                                sx={{
                                                    fontSize: "24px",
                                                    fontWeight: "600",
                                                }}
                                                >
                                                {v.title}
                                                </Typography>
                                            </Box>

                                            <Box
                                                sx={{
                                                display: "flex",
                                                flexDirection: "row",
                                                
                                                }}
                                            >
                                                <Box
                                                sx={{
                                                    width: "12px",
                                                    height: "12.45px",
                                                    pr: "10px",
                                                }}
                                                >
                                                <StarIcon width="100%" sx={{color: "#FAA641"}} />
                                                </Box>
                                                <Box>
                                                <Typography
                                                    sx={{
                                                    fontSize: "14px",
                                                    fontWeight: "600",
                                                    pt: "2px",
                                                    pl: "5px",
                                                    color: "#FAA641",
                                                    }}
                                                >
                                                    {v.rating}
                                                </Typography>
                                                </Box>
                                                <Box>
                                                    <Typography sx={{color:'#9EA3AE'}}>
                                                            {v.review}
                                                    </Typography>
                                                </Box>
                                            </Box>
                                            </Box>
                                        </Box>
                                        </Box>
                                
                        
                        </>
                    );
                    })}
                    
                </Box>
                <Box sx={{
                    width:{lg:'20%',md:'20%',sm:'20%',xs:'0%'}, 
                    display:{lg:'flex',md:'flex',sm:'flex',xs:'none'},
                    flexDirection:'row',
                    justifyContent:'end',
                }}>
                    <Box sx={{
                        width:'50px',
                        heigth:'20px',
                        border:'1px solid #2b817b',
                        borderRadius:'8px',
                        display:'flex',
                        flexDirection:'row',
                        justifyContent:'center'
                    }}>
                        <IconButton aria-label="reset">
                            <SettingsBackupRestoreIcon />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
      </Box>
    
  );
}
